// Redirect non-hash URLs to hash-based URLs (fixes mobile deep link issue)
// mobilde şifremi unuttum linkine tıklanınca mobil app açılıyor, /reset-password/ önüne # eklenirse web den devam edecek
const pathname = window.location.pathname;
if (pathname.startsWith("/reset-password/")) {
  window.location.replace(window.location.origin + "/#" + pathname);
}

// Vue Core
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/index";

// Services
import ApiService from "./core/services/api.service";
import NetworkService from "@/core/services/network.service";
import BridgeService from "@/core/services/bridge.service"; // android -ios mobil app kodları
import GoogleAnalyticsService from "./core/services/analytics/google-analytics.service";
import YandexMetricaService from "@/core/services/analytics/yandex-metrica.service";
import {
  getTranslations,
  prepareConfig,
  updateI18nInstance,
  getCachedTranslations,
  setCachedTranslations,
  getCachedTranslationsDebug,
  clearCachedTranslations,
  cleanupOldCacheKeys,
} from "./core/services/i18n.Api.Service";

// Core Modules
import filter from "@/core/filter/index";
import mixin from "@/core/mixin/index";

// Third Party Libraries
import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: "aes", isCompression: true });

Vue.config.productionTip = false;

// Global Libraries
import PerfectScrollbar from "perfect-scrollbar";
import ClipboardJS from "clipboard";
import $ from "jquery";
import _ from "lodash";

// Set global variables
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
window.$ = $;
window.jQuery = $;
window._ = _;

// Vue Plugins
import "@mdi/font/css/materialdesignicons.css";
import VModal from "vue-js-modal";
import Multiselect from "vue-multiselect";
import { ToggleButton } from "vue-js-toggle-button";

// Custom Assets
import "@/assets/js/EduLock_source_1.1.0";
import "@/assets/css/multiselect.css";

// Initialize API Service
ApiService.init();

// Register Vue Plugins
Vue.use(filter);
Vue.use(VModal);
// Register Global Components
Vue.component("multiselect", Multiselect);
Vue.component("ToggleButton", ToggleButton);

// Date Picker Plugin
import DatePickerPlugin from "@/core/plugins/date-picker-plugin";
Vue.use(DatePickerPlugin);

// Vue Configuration
Vue.config.devtools = true;

// Global Mixins
Vue.mixin({
  ...mixin,
});

// Global Services
Vue.prototype.$networkService = NetworkService;
Vue.prototype.$bridge = BridgeService;

// Version Check
try {
  const version = process.env.VUE_APP_VERSION;
  const localVersion = ls.get("version");

  if (!localVersion || version !== localVersion) {
    ls.set("version", version);
  }
} catch (e) {
  console.warn("Version check failed:", e);
}

// Analytics (Production Only)
if (process.env.NODE_ENV === "production") {
  GoogleAnalyticsService.init("G-QNNFJ1HF3Z");

  try {
    const currentUserFromStorage = ls.get("user");
    const currentUser = JSON.parse(currentUserFromStorage);
    YandexMetricaService.init(
      "102609895",
      currentUser.id,
      currentUser.company_name
    );
  } catch (e) {
    YandexMetricaService.init("102609895");
  }
}

// Uygulamayı çeviri verisiyle mount eder; Vue instance döner.
function mountApp(translationData) {
  const i18n = prepareConfig(translationData);
  if (Vue.prototype.$networkService) Vue.prototype.$networkService.i18n = i18n;

  const app = new Vue({ router, store, i18n, render: (h) => h(App) });
  app.$mount("#app");
  return app;
}

// Önce eski cache anahtarlarını temizle, sonra cache varsa hemen mount et ve arka planda güncelle; yoksa API'den alıp mount et.
cleanupOldCacheKeys();
const cached = getCachedTranslations();

if (cached) {
  const app = mountApp(cached);
  getTranslations()
    .then(({ data }) => {
      setCachedTranslations(data);
      updateI18nInstance(app.$i18n, data);
    })
    .catch(() => {});
} else {
  getTranslations().then(({ data }) => {
    setCachedTranslations(data);
    mountApp(data);
  });
}

// Debug: tarayıcı konsolunda i18n cache’e bakmak için (sadece development)
if (process.env.NODE_ENV !== "production") {
  window.__i18nCache = {
    /** Cache’teki çeviri verisini döndürür (özet + raw). */
    get: getCachedTranslationsDebug,
    /** Sadece ham veri (prepareConfig’e verilen obje). */
    getRaw: getCachedTranslations,
    /** Cache’i siler; sonraki yenilemede API’den tekrar yüklenir. */
    clear: clearCachedTranslations,
  };
}
